var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center mt-20"},[_c('span',[_vm._v("共"+_vm._s(_vm.totalNum)+"条")]),_c('el-pagination',{attrs:{"prev-text":"上一页","next-text":"下一页","background":"","layout":"prev, pager, next","total":_vm.totalNum,"currentPage":_vm.currentPage,"page-size":_vm.pageSize},on:{"current-change":_vm.currentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }